var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "vmlistSticker",
      staticClass: "form-tag",
      class: { "on-mobile": _vm.$store.state.chat.isMobileMode }
    },
    _vm._l(_vm.listSticker, function(item, index) {
      return _c(
        "el-row",
        { key: index, attrs: { gutter: 12 } },
        _vm._l(item, function(st, i) {
          return _c("el-col", { key: i, attrs: { span: 4 } }, [
            _c(
              "span",
              {
                on: {
                  click: function($event) {
                    return _vm.fnSendStickerToLine(st.link)
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "ui-path-img",
                  attrs: { src: st.link }
                })
              ]
            )
          ])
        }),
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15ed5686", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15ed5686","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sticker.vue
// module id = null
// module chunks = 